(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["vue-environment-sticker"] = factory();
	else
		root["vue-environment-sticker"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 